

const SampleData = {

  getJSON() {
    return {
      "blocks": [
       {
        "key": "9fnhv",
        "text": "WatchDOG Elite offers different configurations and features, and CSI Regulatory Compliance offers our customers the option of subscribing to those features that are useful to them. Following is a highlight of the standard features:",
        "type": "unstyled",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "2uu1t",
        "text": "Real-time single lookups - integrate web services with your system, or enable your users to access the WatchDOG Elite site to manually input and review matches",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "6ecnv",
        "text": "File batch processing - upload your file using a web browser, or automate your file runs by sending them to us by secure means (FTPS, SFTP, etc.)",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "5k1ka",
        "text": "Single lookup and batch file screening with optional address and date-of-birth disqualification",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "dlu7o",
        "text": "Single lookup and batch file screening with review and resolve capabilities",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "e2to",
        "text": "Management of Good and Blocked Customer Lists",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "6pcrr",
        "text": "Automated list updates - CSI handles the burden of monitoring, gathering, cleansing and deploying the list for you",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "b1mlt",
        "text": "Auditing and Reporting - Previously scanned data can be reported on for documentation and auditing purposes",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "7ue2o",
        "text": "Advanced Name Matching Algorithm",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "85kgu",
        "text": "Adjustable tolerance level that helps to control the number of false positive matches",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "8crag",
        "text": "Global Watch Lists scanning such as OFAC, FBI, Interpol, BIS, OSFI, HM Treasury, etc.",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "a8c57",
        "text": "Workflow Functionality",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "76kgl",
        "text": "Watch List Screening Add-on Components",
        "type": "header-three",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "74ji1",
        "text": "In addition to the standard components, WatchDOG Elite consists of several features that may be included to meet your compliance needs:",
        "type": "unstyled",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "6uksp",
        "text": "Internal Watch Lists – Allows users to create and manage custom watch lists.",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "c1405",
        "text": "Divisions – Allows the organization to classify and divide data that requires screening by group or business unit.",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "84c6r",
        "text": "Customer Data Management (CMD) – Used to consolidate and automate the scanning of your customer list based on your compliance needs. For example, the CMD module can ensure that your customers are automatically re-scanned whenever the OFAC SDN list is updated.",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "5fg5",
        "text": "Street Address Searching – In addition to screening names, WatchDOG Elite can screen address data consisting of a street address, city, state, postal code and country. If the address submitted for screening matches to the watch list, a match will be returned whether or not the corresponding name is a match or not.",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "a5ns0",
        "text": "Exact ID Matching – Allows users to run exact ID searches of Social Security Numbers and National Provider Identifiers against the Death Master File and National Plan & Provider Enumeration System registry, respectively.",
        "type": "unordered-list-item",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "9l8i8",
        "text": "",
        "type": "unstyled",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       },
       {
        "key": "8ebb",
        "text": "",
        "type": "unstyled",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
       }
      ],
      "entityMap": {
        
      }
    }
  },
  getPlainText() {
    return `Section Title
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque pharetra at ipsum eu volutpat. Pellentesque aliquet dui est, eu vestibulum libero pulvinar id. Suspendisse a nibh tempus, scelerisque quam nec, aliquam nunc. Aenean blandit, mauris suscipit vestibulum feugiat, erat tortor pellentesque massa, a mollis tortor mauris eget nulla. Sed eleifend arcu non sem suscipit rhoncus vel sit amet magna. Nulla lacinia lorem a dui efficitur, nec hendrerit sapien varius. Morbi in quam mauris. Etiam viverra nisl ex, ac hendrerit odio fringilla a. Curabitur porta in orci vitae iaculis. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Integer malesuada augue id luctus ullamcorper. Nulla tincidunt imperdiet ipsum ac suscipit.
    
    Sub-section Title
    Nam eget risus non nisi molestie blandit vitae non enim. Sed vehicula risus vel suscipit euismod. Integer et turpis augue. Cras pretium ligula ipsum, sed sagittis ex varius et. Donec non felis sed dolor rhoncus tempor. Cras tristique imperdiet mi vitae mollis. Nulla mollis accumsan enim at tristique. Nullam efficitur lorem et orci viverra, eu dignissim purus gravida. In pharetra massa vel iaculis convallis. Quisque a eros imperdiet, cursus mauris id, facilisis nisl. Curabitur dapibus sem sit amet tortor maximus, vel condimentum sapien finibus.
    
    Lists
    Item One
    Item Two
    Item Three
    Item One
    Item Two
    Item Three
    Code Block
    function foo(bar){
      return bar;
    }`;
  }

}

export default SampleData;
